import { render } from "./Button.vue?vue&type=template&id=cd54cc30&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=cd54cc30&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/check/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd54cc30"]])

export default __exports__